import React, { Suspense } from "react";

const NS = "BookingCardListLazyLoader";

export default function BookingCardListLazyLoader() {
  const BookingCardListContainer = React.lazy(() => import("./container"));

  return (
    <Suspense fallback={<></>}>
      <BookingCardListContainer />
    </Suspense>
  );
}
